import React from "react";
import {DateRange} from "@material-ui/icons";

const education = (object) => {
    return (
        <article className="education">
            <h3>Utdanning</h3>
            <ul>
                {object.map((edu,i) =>
                    <li className="educationList" key={i}>
                        <div className="eduTitle">
                            <h4 className="">{edu.degree}</h4>
                            <small>{edu.university}</small>
                        </div>
                        <div className="eduDate">
                            <div><DateRange /></div><div className="date">{edu.startDate} &mdash; {edu.endDate}</div>
                        </div>
                        <div>
                            <p className="description">{edu.description}</p>
                        </div>
                    </li>
                )}
            </ul>
        </article>
    )
}

export default education